/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {string} gameId
 * @param {(row: Record<string, unknown>) => void} onMessage
 * @returns {() => void} cleanup
 */
export function subscribeGameMessages(supabase, gameId, onMessage) {
  const channel = supabase
    .channel(`messages:${gameId}`)
    .on(
      "postgres_changes",
      { event: "INSERT", schema: "public", table: "messages", filter: `game_id=eq.${gameId}` },
      (payload) => {
        if (payload.new && typeof payload.new === "object") {
          onMessage(/** @type {Record<string, unknown>} */ (payload.new));
        }
      }
    )
    .subscribe();

  return () => {
    void supabase.removeChannel(channel);
  };
}
